import React, { Suspense, lazy } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';
import CookieBanner from './components/CookiesBanner';
import { HelmetProvider } from 'react-helmet-async';
import FloatingContact from './components/FloatingContact';

const Home = lazy(() => import('./components/Home'));
const ProjectDetail = lazy(() => import('./components/ProjectDetail'));
const BlogList = lazy(() => import('./components/BlogList'));
const BlogDetail = lazy(() => import('./components/BlogDetail'));
const PolicyPage = lazy(() => import('./components/PolicyPage'));
const Inversor = lazy(() => import('./components/Inversor'));

function Structure() {
    return (
        <HelmetProvider>
            <div>
                <Navbar basePath="" />
                <Suspense fallback={<div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img src={process.env.PUBLIC_URL + '/sources/loading_icon.gif'} alt="Loading..." width="50" /></div>}>
                    <Routes>
                        <Route path="/" element={<Home basePath="" />} />
                        <Route path="/proyecto/:id" element={<ProjectDetail basePath="" />} />
                        <Route path="/blog" element={<BlogList basePath="" />} />
                        <Route path="/blog/:id" element={<BlogDetail basePath="" />} />
                        <Route path="/politica/:id" element={<PolicyPage basePath="" />} />
                        <Route path="/inversion" element={<Inversor basePath="" />} />
                    </Routes>
                </Suspense>
                <FloatingContact basePath="" />
                <CookieBanner />
                <Footer basePath="" />
            </div>
        </HelmetProvider>
    );
}

export default Structure;

